import { apiService } from './apiService';
import { commonDataEndpoints } from '../api/apiEndpoint';
import { CapitalRaisingType, Country, Currency, EmploymentStatus, FundCapitalHistoryType, Industry, InvestorSector, Relationship, Round, SearchCompany, SearchFund, StockChangeSubType, StockChangeType, StockType } from '@/common/types/common';

interface IndustryCode {
  id: number;
  division1: string;
  division2: string;
  division3: string;
  code: string;
  name: string;
}

export const commonService = {

  async checkDuplicateValue(type: string, value: string): Promise<{exists: boolean}> {
    const response = await apiService.get<{exists: boolean}>(
      commonDataEndpoints.checkDuplicate(),
      {type, value}
    );
    return response;
  },
  
  async getEmploymentStatus(): Promise<EmploymentStatus[]> {
    const response = await apiService.get<EmploymentStatus[]>(
      commonDataEndpoints.getEmploymentStatus()
    );
    return response;
  },

  async getIndustries(): Promise<Industry[]> {
    const response = await apiService.get<Industry[]>(
      commonDataEndpoints.getIndustries()
    );
    return response;
  },


  async getCountries(): Promise<Country[]> {
    const response = await apiService.get<Country[]>(
      commonDataEndpoints.getCountries()
    );
    return response;
  },
  
  async getRelationships(): Promise<Relationship[]> {
    const response = await apiService.get<Relationship[]>(
      commonDataEndpoints.getRelationships()
    );
    return response;
  },

  async getCapitalRaisingTypes(): Promise<CapitalRaisingType[]> {
    const response = await apiService.get<CapitalRaisingType[]>(
      commonDataEndpoints.getCapitalRaisingTypes()
    );
    return response;
  },

  async getStockTypes(): Promise<StockType[]> {
    const response = await apiService.get<StockType[]>(
      commonDataEndpoints.getStockTypes()
    );
    return response;
  },      

  async getStockChangeTypes(): Promise<StockChangeType[]> {
    const response = await apiService.get<StockChangeType[]>(
      commonDataEndpoints.getStockChangeTypes()
    );
    return response;
  },

  async getStockChangeSubTypes(): Promise<StockChangeSubType[]> {
    const response = await apiService.get<StockChangeSubType[]>(
      commonDataEndpoints.getStockChangeSubTypes()
    );
    return response;
  },  

  async getRounds(): Promise<Round[]> { 
    const response = await apiService.get<Round[]>(
      commonDataEndpoints.getRounds()
    );
    return response;
  },

  async searchCompany(query: string): Promise<SearchCompany[]> {
    const response = await apiService.get<SearchCompany[]>(
      commonDataEndpoints.searchCompany(),
      { keyword: query }
    );
    return response;
  },

  async searchFund(query: string): Promise<SearchFund[]> {
    const response = await apiService.get<SearchFund[]>(
      commonDataEndpoints.searchFund(),
      { params: { keyword: query } }
    );
    return response;
  },

  async getCurrencies(): Promise<Currency[]> {
    const response = await apiService.get<Currency[]>(
      commonDataEndpoints.getCurrency()
    );
    return response;
  },

  async getFundCapitalTypes(): Promise<FundCapitalHistoryType[]> {
    const response = await apiService.get<FundCapitalHistoryType[]>(
      commonDataEndpoints.getFundCapitalTypes()
    );
    return response;   
  },  

  async getIndustryCodes(): Promise<IndustryCode[]> {
    const response = await apiService.get<IndustryCode[]>(
      commonDataEndpoints.getIndustryCodes()
    );
    return response;
  },

  async getInvestorSectors(companyId: number): Promise<InvestorSector[]> {
    const response = await apiService.get<InvestorSector[]>(
      commonDataEndpoints.getInvestorSectors(),
      { companyId }
    );
    return response;
  },
};
